import {
  EPG_EVENT_FOCUS,
  EPG_EVENT_FOCUS_CLEARING,
  EPG_EVENT_PLAYS,
  EPG_EVENT_PLAYS_CLEARING,
} from '../actions/event/constants';

const initialState = {
  error: null,
  loading: false,
  main: {},
  focus: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EPG_EVENT_PLAYS:
      return {
        ...state,
        error: null,
        loading: false,
        main: { ...action.payload },
      };
    case EPG_EVENT_PLAYS_CLEARING:
      return {
        ...state,
        error: null,
        loading: false,
        main: {},
      };
    case EPG_EVENT_FOCUS:
      return {
        ...state,
        error: null,
        loading: false,
        focus: { ...action.payload },
      };
    case EPG_EVENT_FOCUS_CLEARING:
      return {
        ...state,
        error: null,
        loading: false,
        focus: false,
      };
    default:
      return state;
  }
};
